import $http from '@/libs/axios'

const unauthenticated = { skipAuth: true }

class MfaAPI {
  static async challenge(mfaToken: string, code: string) {
    return (await $http.post('/users/mfa/challenge', { mfa_token: mfaToken, code }, unauthenticated)).data
  }

  static async setup(mfaToken?: string) {
    if (mfaToken) {
      return (await $http.post('/users/mfa/setup', { mfa_token: mfaToken }, unauthenticated)).data
    }
    return (await $http.post('/users/mfa/setup', {})).data
  }

  static async confirm(code: string, mfaToken?: string) {
    const body: { code: string, mfa_token?: string } = { code }
    if (mfaToken) body.mfa_token = mfaToken
    return (await $http.post('/users/mfa/confirm', body, mfaToken ? unauthenticated : {})).data
  }

  static async status() {
    return (await $http.get('/users/mfa')).data
  }

  static async regenerateRecoveryCodes(code: string) {
    return (await $http.post('/users/mfa/recovery-codes', { code })).data
  }

  static async disable(password: string, code: string) {
    return (await $http.delete('/users/mfa', { data: { password, code } })).data
  }
}

export default MfaAPI
